import React from 'react';
import styled from 'styled-components';

interface StyledProps {
    $maxHeight?: number;
    $fillViewHeight?: boolean;
}

const Styled = styled.div<StyledProps>`
    height: ${(p) => (p.$fillViewHeight ? '100vh' : '100%')};
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-direction: row;

    .lottie-wrap {
        height: 100vh;
        max-height: ${(p) => (p.$maxHeight ? `${p.$maxHeight}px` : '450px')};
        margin: auto 0;
        svg {
            height: 100%;
            width: 100%;
        }
    }
`;

interface ChildrenProps {
    children?: React.ReactNode;
}

export interface LoadingWrapProps {
    maxHeight?: number;
    fillViewHeight?: boolean;
}

export const LoadingWrap = ({
    children,
    maxHeight,
    fillViewHeight = true
}: LoadingWrapProps & ChildrenProps): JSX.Element | null => {
    return (
        <Styled className="loading-wrap" $maxHeight={maxHeight} $fillViewHeight={fillViewHeight}>
            <div className="lottie-wrap">{children}</div>
        </Styled>
    );
};
